import { c as _c } from "react/compiler-runtime";
import { isVin } from '@onefootprint/core';
import type { FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormInput, { type FormInputProps } from './form-input';
export type FormVinProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
} & Omit<FormInputProps<TFieldValues>, 'name' | 'rules' | 'inputMode'>;
export default function FormVin(t0) {
  const $ = _c(14);
  let props;
  let rules;
  if ($[0] !== t0) {
    ({
      rules,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = rules;
  } else {
    props = $[1];
    rules = $[2];
  }
  const {
    t
  } = useTranslation("ui");
  let t1;
  if ($[3] !== t) {
    t1 = value => {
      if (!value) {
        return true;
      }
      if (!isVin(value)) {
        return t("components.form.vin.errors.invalid");
      }
      return true;
    };
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rules || $[6] !== t1) {
    t2 = {
      validate: t1,
      ...rules
    };
    $[5] = rules;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const vinRules = t2;
  let t3;
  if ($[8] !== props) {
    t3 = e => {
      e.target.value = e.target.value.toUpperCase();
      props.onChange?.(e);
    };
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props || $[11] !== t3 || $[12] !== vinRules) {
    t4 = <FormInput {...props} rules={vinRules} maxLength={17} onChange={t3} />;
    $[10] = props;
    $[11] = t3;
    $[12] = vinRules;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}